export const categories = [
  {
    slug: 'feature-guide',
    name: '功能指南',
    description: '全面了解一起草平台的核心功能与特色，快速上手使用',
    icon: 'ri-guide-line',
    articleCount: 24,
    color: 'accent',
  },
  {
    slug: 'tutorial',
    name: '使用教程',
    description: '详细的操作教程与使用技巧，助你成为高效创作者',
    icon: 'ri-book-open-line',
    articleCount: 36,
    color: 'primary',
  },
  {
    slug: 'news',
    name: '最新动态',
    description: '平台更新公告、行业资讯与热门话题第一时间掌握',
    icon: 'ri-newspaper-line',
    articleCount: 18,
    color: 'secondary',
  },
  {
    slug: 'faq',
    name: '常见问题',
    description: '汇集用户常见疑问与解答，快速解决使用中的各类问题',
    icon: 'ri-question-answer-line',
    articleCount: 42,
    color: 'accent',
  },
];